import { render, staticRenderFns } from "./SktIb.vue?vue&type=template&id=861f56e8"
import script from "./SktIb.vue?vue&type=script&lang=js"
export * from "./SktIb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports